
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CompanionApp } from '@/config/companionApps';
import { CompanionBannerModel } from './CompanionBannerModel';

/**
 * One free Assisty companion app at a time, between Warbler's AppBanner and
 * the page, on Warbler's classic pages only: Atlas draws its own on /assistant/*
 * (docs/features/companion-app-banner/prd.md rev 2, mockup boards W1–W4).
 * Behaviour lives in CompanionBannerModel; this component only renders.
 */
@Component
export default class CompanionAppBanner extends Vue {
  @Prop({ default: null })
  public storeId!: number | null;

  public model = new CompanionBannerModel();

  get app(): CompanionApp | null {
    return this.model.visibleApp(this.$route.path);
  }

  @Watch('storeId', { immediate: true })
  public onStoreId(storeId: number | null) {
    this.model.load(storeId);
  }

  @Watch('app', { immediate: true })
  public onApp(app: CompanionApp | null) {
    if (app) {
      this.model.markViewed();
    }
  }

  public onSetUp() {
    this.model.retire('click');
  }

  /** A middle-click opens the listing too, so it retires the app like a click. */
  public onAuxClick(event: MouseEvent) {
    if (event.button === 1) {
      this.model.retire('click');
    }
  }

  public onDismiss() {
    this.model.retire('dismiss');
  }
}
